module.exports = __webpack_public_path__ + "assets/img/thumb-Webprofits-2021-Video-Services-Showreel-Video.b16d98cc.webp";